import React from 'react'

export default function () {
    return (
        <div className="">
           <h4 style={{margin: '1rem 0 2rem'}}>Your bet was posted!</h4>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/templates/modals/event-bet-posted.js